import { cn } from "@marketing-sites/utils/cn";

/**
 * Small label tooltip shown above a logo on hover/focus (desktop) or press
 * (mobile). Chalk fill with a hairline (0.5px) 40%-black stroke and a downward
 * caret, matching the intercom.com brand. Revealed via the parent link's
 * `group/logo` state.
 */
export const LogoPill = ({
  label,
  stat,
  className,
}: {
  label: string;
  stat?: string;
  className?: string;
}) => (
  <span
    aria-hidden
    className={cn(
      "pointer-events-none absolute bottom-full left-1/2 z-10 mb-2 -translate-x-1/2",
      "opacity-0 transition-opacity duration-200",
      // Scoped to real pointer devices — touch browsers apply :hover after a tap, flashing the pill mid-navigation.
      "group-focus-visible/logo:opacity-100 group-active/logo:opacity-100 [@media(hover:hover)]:group-hover/logo:opacity-100",
      className,
    )}
  >
    <span className="bg-chalk border-off-black/40 text-off-black relative block border-[0.5px] px-2.5 py-1 text-[13px] leading-none">
      {stat ? (
        <span className="flex flex-col items-center gap-0.5 whitespace-nowrap py-0.5 text-center">
          <span className="font-medium">{stat}</span>
          <span className="text-off-black/60 text-[11px]">{label}</span>
        </span>
      ) : (
        <span className="whitespace-nowrap">{label}</span>
      )}
      {/* Caret as a rotated square straddling the box's bottom edge: its body
          hides the border seam, and the two outer edges carry the same 0.5px
          stroke as the box — uniform, not thicker at the tip. */}
      <span className="bg-chalk border-off-black/40 absolute left-1/2 top-full size-[7px] -translate-x-1/2 -translate-y-1/2 rotate-45 border-b-[0.5px] border-r-[0.5px]" />
    </span>
  </span>
);
